import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
        <section>
          <header id="page-title">
            <div className="container">
              <h1>404 Error</h1>
            </div>
          </header>
          <section className="container">
          <br/>
          <h2>Page not found</h2>
          <p>Sorry, the page you are looking for does not exist.</p>

          </section>

        </section>
    );
  }
}

export default NotFound;
